
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment analyser la concurrence sur Google Ads en 4 étapes",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Suivez ce guide pour analyser efficacement la concurrence sur Google Ads en 4 étapes essentielles, et améliorez la performance de vos campagnes publicitaires.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment analyser la concurrence sur Google Ads en 4 étapes",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Ce guide détaillé vous présentera comment analyser la concurrence sur Google Ads en 4 étapes essentielles.",
        },
      ],
    };
  },
};
